/*
 * @Author: wzc
 * @Date: 2024-07-25 10:42:36
 * @LastEditors: wzc
 * 超赛平台 base mixins
 * @LastEditTime: 2024-07-25 19:11:02
 * 通过服务器传的海报id,从本地配置文件中到对应的配置项目，但是目前图片还是取服务器的，其他字段都取本地配置文件
 */
export default {
  props: {},
  data() {
    return {
      posterViewList: [
        {
          // 技术统计 【单人：横版|竖版|方版】
          posterView: 'html/HTML_BAR_INDICATOR_ITEM', // 对应的海报视图组件路径
          posterIds: [1, 2, 3], // 哪些海报id适用这个组件
        },
        {
          // 技术统计 【双人：横版|竖版|方版】
          posterView: 'html/HTML_BAR_INDICATOR_ITEM',
          posterIds: [4, 5, 6],
        },
        {
          // 技术统计 【采访：横版|竖版|方版】
          posterView: 'html/HTML_BAR_INDICATOR_ITEM',
          posterIds: [7, 8, 9],
          posterPermissions: ['edit'], //海报中有些区域需要编辑
        },
        {
          // 技术统计 【横版】：表格 + 单个照片
          posterView: 'html/HTML_TABLE_SINGLEIMAGE',
          // posterView: 'html/touchEvent2Draggable',
          posterIds: [10],
        },
      ],
    }
  },
  methods: {
    async makeFileDataHandler(posterId, serverFileData, type) {
      let curPosterViewItem = null
      console.debug('posterViewPath:', curPosterViewItem, posterId)
      this.posterViewList.forEach((posterViewItem) => {
        if (posterViewItem.posterIds.includes(posterId)) {
          curPosterViewItem = posterViewItem
        }
      })
      console.debug('posterViewPath:', curPosterViewItem, posterId)
      import(
        `@components/dataPoster/${curPosterViewItem.posterView}/profile.js`
      )
        .then((res) => {
          console.log('脚本加载成功:', res)
          res.default.forEach((posterCustomOpt) => {
            if (posterCustomOpt.posterId === posterId) {
              if (curPosterViewItem.posterPermissions) {
                posterCustomOpt.posterPermissions =
                  curPosterViewItem.posterPermissions
              }
              // 底图
              posterCustomOpt.posterBgImageUrl = serverFileData.posterBgImageUrl
              posterCustomOpt.posterBgImageUrlBase64 =
                serverFileData.posterBgImageUrlBase64
                  ? serverFileData.posterBgImageUrlBase64
                  : serverFileData.posterBgImageUrl
              // L图
              posterCustomOpt.posterLImageUrl = serverFileData.posterLImageUrl
              posterCustomOpt.posterLImageUrlBase64 =
                serverFileData.posterLImageUrlBase64
                  ? serverFileData.posterLImageUrlBase64
                  : serverFileData.posterLImageUrl
              if (posterCustomOpt.fileList) {
                posterCustomOpt.fileList.forEach((picItem, picIndex) => {
                  picItem.url = serverFileData.fileList[picIndex].url
                  picItem.urlBase64 =
                    serverFileData.fileList[picIndex].urlBase64
                  picItem.styleItem.zIndex =
                    posterCustomOpt.maxZindex_fileList - picIndex
                })
              }
              if (type) {
                // 目前只有切换尺寸时用到
                posterCustomOpt.type = type
              }
              this.fileData = JSON.parse(JSON.stringify(posterCustomOpt))
              console.debug(
                '脚本加载成功 fileData:',
                this.fileData,
                this.cssDynamicObj,
                this.cssDynamicObj.mixvw
              )
              this.setDataPosterRootCssStyle(
                posterCustomOpt,
                this.cssDynamicObj
              )
            }
          })
        })
        .catch((error) => {
          console.error('脚本加载失败', error)
        })
    },
    setDataPosterRootCssStyle(posterCustomOpt, cssDynamicObj) {
      // 增加该主题自定义css样式和mixvw
      const colorKeys = Object.keys(posterCustomOpt.posterColors)
      const styleArr = [`--mixtmt_dataPoster_mixvw:${cssDynamicObj.mixvw}`]
      colorKeys.forEach((key) => {
        if (key) {
          styleArr.push(
            `--mixtmt_dataPoster_${key}:${posterCustomOpt.posterColors[key]}`
          )
        }
      })
      // if (currThemeObj.comImgStyle) {
      //   // 设置普通的图片
      //   currThemeObj.comImgStyle.forEach((imgName) => {
      //     if (imgName.indexOf('.') > -1) {
      //       styleArr.push(
      //         `--mixtmt_${imgName.split('.')[0]}: url(/static/${
      //           currThemeObj.sportType
      //         }/${currThemeObj.imageUrl}/${imgName})`
      //       )
      //     }
      //   })
      // }
      const styleId = `mixtmt_dataPoster_rootStyle`
      let styleDom = document.getElementById(styleId)
      if (!styleDom) {
        let styleDom = document.createElement('style')
        styleDom.id = styleId

        styleDom.textContent = `:root {${styleArr.join(';')}}`
        document.head.appendChild(styleDom)
      } else {
        styleDom.textContent = `:root {${styleArr.join(';')}}`
      }
    },
  },
}
